import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';

import { LicensingModule } from '../licensing/licensing.module';
import { ModalsModule } from '../modals/modals.module';
import { RestApiModule } from '../restapi/restapi.module';
import { UserModule } from '../user/user.module';
import { UserLoginComponent } from './user-login.component';
import { LoginService } from './user-login.service';

@NgModule({
    imports: [CommonModule, LicensingModule, FormsModule, ModalsModule, RouterModule, HttpModule, RestApiModule, UserModule],
    declarations: [
        UserLoginComponent
    ],
    providers: [
        LoginService
    ],
    exports: [
        UserLoginComponent,
    ]
})
export class LoginModule { }



// WEBPACK FOOTER //
// ./src/app/login/login.module.ts